/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-05-11 15:10:24
 * @LastEditors: luckymiaow
 */

import type { IDomEditor, IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import { deepCopy } from '../../util';
import type { EditorProps } from '../types';

export default ({ emits, getBindValue }: { emits: any; getBindValue: EditorProps }) => {
  // 编辑器配置
  const editorConfig: Partial<IEditorConfig> = getBindValue;

  editorConfig.onChange = (editor: IDomEditor) => {
    emits('update:value', editor.getHtml());
  };

  // 工具栏配置
  const toolbarConfig: Partial<IToolbarConfig> = getBindValue.toolbarConfig;

  return { editorConfig, toolbarConfig };
};
